
export const VerificationWorkflow = 'VerificationWorkflow/';
export const GetWorkflowMapping = VerificationWorkflow + 'GetWorkflowMapping';
export const ImportManagementHistorySearch = VerificationWorkflow + `ImportManagement/Search`;
export const GetImportDetailsById = VerificationWorkflow + `ImportManagement/Detail/`;
export const IsImportInProgressForScorecard = VerificationWorkflow + 'IsImportInProgressForScorecard/';
export const IsImportInProgressForOrganisation = VerificationWorkflow + 'IsImportInProgressForOrganisation/';
export const IsImportInProgressForUser = VerificationWorkflow + 'IsImportInProgressForUser/';
export const GetOrganisationImportDetails = VerificationWorkflow + `ImportManagement/Organisation/Details`;